import React from 'react';

import { Button, Form, Col, } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green, } from '@material-ui/core/colors';
import SaveIcon from '@material-ui/icons/Save';

import ToastAnimated, { showToast, } from '../../ui-lib/toast';
import 'react-toastify/dist/ReactToastify.css';


const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -10,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  table: {
    minWidth: 300,
  },
}))


const DEFAULT_DATA = Object.freeze({
  name: '',
});


function ServerForm({ data, onSubmit, loading, }) {
  const classes = useStyles();
  const [formData, setFormData] = React.useState(DEFAULT_DATA);
  const [borderError, setBorderError] = React.useState('');


  function _onSubmit() {
    if (!formData.name) {
      showToast({
        type: 'error',
        message: 'O host precisa de um nome',
      })
      return setBorderError('#ff0000');
    }

    setBorderError('');

    if (!loading) {
      onSubmit(formData);
      setFormData(DEFAULT_DATA);
    }
  }

  function handleChange(event) {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  }

  React.useEffect(() => {
    if (undefined != data) {
      setFormData({
        name: data.name || '',
      });
    } else {
      setFormData(DEFAULT_DATA);
    }
  }, [data]);


  return (
    <Form>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label>
            Nome
          </Form.Label>
          <Form.Control
            style={{
              borderColor: borderError,
            }}
            placeholder="Nome"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </Form.Group>
      </Form.Row>

      <div className={classes.wrapper}>
        <ToastAnimated />
        <Button
          variant="dark"
          disabled={loading}
          onClick={_onSubmit}
        >
          <SaveIcon /> Salvar
        </Button>
        {
          loading ?
          <CircularProgress
            size={24}
            className={classes.buttonProgress}
          /> :
          null
        }
      </div>
    </Form>
  );
}

export default ServerForm;
